export default [{
    title: '工具',
    route: 'tool',
    name: 'tool'
}];


// WEBPACK FOOTER //
// ./src/config/top_nav/index.js